$(document).ready(function() {
    $('.minimizeInTitle').click(function() {
        $(this).toggleClass("maximizeInTitle");
    });
    
    $('.maximizeInTitle').click(function () {
        $(this).toggleClass("minimizeInTitle");
    });
    
    $('.minimize').click(function () {
        $(this).toggleClass("maximize");
    });

    $('.maximize').click(function () {
        $(this).toggleClass("minimize");
    });

    var responsiveMouseEnter = function() {
        var cover = $(this).find('.responsive-image-caption-item-cover');
        var overlay = $(this).find(".responsive-image-caption-item-cover-overlay:first");

        cover.stop().animate({ opacity: 0, queue: false }, 100);
        overlay.stop().animate({ top: '20%', queue: false }, 160);
    };

    var responsiveMouseLeave = function() {
        var cover = $(this).find('.responsive-image-caption-item-cover');
        var overlay = $(this).find(".responsive-image-caption-item-cover-overlay:first");

        cover.stop().animate({ opacity: .9, queue: false }, 100);
        overlay.stop().animate({ top: '100%', queue: false }, 160);
    };

    $(".responsive-image-caption-item").on("mouseenter", responsiveMouseEnter)
        .on("mouseleave", responsiveMouseLeave);

    $(".cms_section").on("mouseenter", ".responsive-image-caption-item", responsiveMouseEnter)
        .on("mouseleave", ".responsive-image-caption-item", responsiveMouseLeave);

});